import $http from "./http";
export const getExcel = data => {
    return $http.post("/collect/column_collection/getExcel", data, {
        responseType: "blob"
    });
};

export const getYearData = data => {
    return $http.post("/collect/column_collection/getYearData", data);
};

export const getMonthData = data => {
    return $http.post("/collect/column_collection/getMonthData", data);
};

export const getDayData = data => {
    return $http.post("/collect/column_collection/getDayData", data);
};
